import { createFileRoute } from '@tanstack/react-router'

import { BOILER_ROOM_DOMAIN } from '@/components/module-synoptic/module-synoptic-domain'
import { editRouteOptions } from '@/components/module-synoptic/module-synoptic-route-options'

// Édition d'un synoptique de chaufferie. Garde OuiSense, parseParams et préchargements sont communs
// aux catégories de synoptiques à modules (cf. module-synoptic-route-options).
export const Route = createFileRoute('/_dashboard/site/$id/boiler-room/technical/manage/$synopticId/')(editRouteOptions(BOILER_ROOM_DOMAIN))
